var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3A99D7"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2682BF"
    },
    d: "M511.176,278.419C499.802,409.304,390.017,512,256.165,512c-3.132,0-6.264,0-9.396-0.165 L125.61,390.676l219.735-278.089L511.176,278.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD630"
    },
    d: "M136.984,106.982c68.904,0,125.28,0,194.678,0c10.55,0,19.122,8.572,19.122,19.122v114.071v27.034 v95.938v8.242c0,12.858-10.385,23.243-23.243,23.243H136.984c-10.55,0-19.122-8.572-19.122-19.122V126.104 C117.862,115.554,126.435,106.982,136.984,106.982z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 118.191,
    style: {
      fill: "#F7F7F8"
    },
    width: 208.195,
    height: 265.069
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E84F4F"
    },
    cx: 369.737,
    cy: 332.492,
    r: 65.612
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E84F4F"
    },
    d: "M147.204,139.951h26.869v30.99h-26.869V139.951z M147.204,306.442h26.869v30.99h-26.869V306.442z  M147.204,250.89h26.869v30.99h-26.869V250.89z M147.204,195.338h26.869v30.99h-26.869V195.338z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M186.766,151.325h91.817v8.078h-91.817L186.766,151.325L186.766,151.325z M186.766,317.816h91.817 v8.078h-91.817L186.766,317.816L186.766,317.816z M186.766,262.264h91.817v8.078h-91.817L186.766,262.264L186.766,262.264z  M186.766,206.712h91.817v8.078h-91.817L186.766,206.712L186.766,206.712z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD630"
    },
    cx: 369.737,
    cy: 332.492,
    r: 55.392
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M322.926,334.3l17.639-1.978l19.122,16.979c0,0,9.232-38.573,52.42-47.64 c-21.1,11.374-34.122,33.958-42.859,65.113c-2.143,7.912-7.912,5.769-9.726,3.461c-2.967-3.792-22.748-26.375-36.595-36.101V334.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E84F4F"
    },
    d: "M215.943,90.828h2.967c-0.824-1.318-1.318-2.967-1.318-4.615v-9.891c0-5.44,4.946-9.89,11.044-9.89 h11.374c6.099,0,11.044,4.451,11.044,9.89v9.89c0,1.649-0.494,3.132-1.319,4.615h2.967c20.276,0,36.759,15.001,36.759,33.133l0,0 H179.019l0,0c0-18.297,16.649-33.133,36.759-33.133h0.165V90.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C94545"
    },
    d: "M234.406,66.431h5.769c6.099,0,11.044,4.451,11.044,9.89v9.89c0,1.649-0.494,3.132-1.319,4.615h2.967 c20.276,0,36.759,15.001,36.759,33.133l0,0h-55.222L234.406,66.431L234.406,66.431z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.f11ecaf90cd4d6b7b7f22a39e9b8ed54.svg";
export { ForwardRef as ReactComponent };